<dx-popup
  width="20%"
  height="40%"
  [showTitle]="true"
  [dragEnabled]="false"
  title="Filter"
  [(visible)]="sideFilter.visible">

  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Appliquer',
            onClick: apply
        }">
  </dxi-toolbar-item>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Réinitialiser',
            onClick: reset
        }">
  </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <dx-form id="form"
             [colCount]="1"
             [formData]="sideFilter.filter">

      <dxi-item [label]="{text: 'Domaines'}">
        <div *dxTemplate>
          <lib-domains-selector-dropdown [title]="" [domains]="domains"
                                         [dropdownWidth]="500"
                                         [(value)]="sideFilter.filter.domains"></lib-domains-selector-dropdown>
        </div>
      </dxi-item>

      <dxi-item [label]="{text: 'Grouper Par'}" dataField="groupBy" editorType="dxSelectBox"
                [editorOptions]="{ items: sideFilter.groupByList, value: sideFilter.filter.groupBy, displayExpr: 'text', valueExpr: 'value' }"></dxi-item>
    </dx-form>
  </div>
</dx-popup>
